import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../auth/auth.service';
import { WorklistService } from './worklist.service';
import { Router, NavigationEnd } from '@angular/router';

import { WorklistRoutingModule } from './worklist-routing.module';
import { WorklistListComponent } from './worklist-list/worklist-list.component';
import { WorklistEditComponent } from './worklist-edit/worklist-edit.component';
import { TemplateModule } from "../template/template.module";
import { MenubarComponent } from './menubar/menubar.component';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { DropdownModule, InputTextModule, PasswordModule } from 'primeng/primeng';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  imports: [
    CommonModule,
    WorklistRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TemplateModule,
    MenubarModule,
    TableModule,
    ButtonModule,
    DialogModule,
    PasswordModule,
    MessagesModule,
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
  ],
  providers: [AuthService, WorklistService],
  declarations: [WorklistListComponent, WorklistEditComponent, MenubarComponent]
})
export class WorklistModule {
  constructor(auth: AuthService, router: Router) {

    // Check login only if we are trying to use this module
    router.events
      .subscribe((event: NavigationEnd) => {
        if(event instanceof NavigationEnd && event.urlAfterRedirects.startsWith('/settings/worklists')) {

          // Check Permissions (skip checkLogin because it's checked in parent module /settings)
          auth.checkPermissions('worklist');

        }
      });

  }
}
